import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CS from "../../assets/CS 1.webp";
import real_time_accuracy from "../../assets/real_time_accuracy.webp";
import CS3 from "../../assets/CS 3.webp";
import frame from "../../assets/frame.webp";
import CS5 from "../../assets/CS 5.webp";
import cardImage1 from "../../assets/delivery.png";
import cardImage2 from "../../assets/timer.png";
import cardImage3 from "../../assets/tracking.png";
import cardImage4 from "../../assets/CS8.png";
import "./FiveCard.css";

import centralized_booking_dashboard from '../../assets/internalImages/Enterprise/_kfwo_centralized_booking_dashboard.webp';
import real_time_tracking from '../../assets/internalImages/Enterprise/_kfwo_real_time_tracking.webp';
import recurring_deliveries from '../../assets/internalImages/Enterprise/_kfwo_recurring_deliveries_.webp';
import smart_billing_wallet from '../../assets/internalImages/Enterprise/_kfwo_smart_billing_wallet.webp';
import wide_range_of_vehicles from '../../assets/internalImages/Enterprise/_kfwo_wide_range_of_vehicles.webp';

const KeyFeatures = () => {
  return (
    <section className="py-5 bg-white">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold">Key Features We Offer</h2>

        <div className="row g-4">
          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0 rounded-5"
              style={{
                height: "350px",
                background: "linear-gradient(180deg, #fdefe7, #f5b48f)",
                overflow: "hidden",
              }}
            >
              <div
                className="card-body d-flex flex-column"
                style={{ height: "100%" }}
              >
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Recurring deliveries
                </h3>

                <div
                  style={{
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "start",
                  }}
                >
                  <img
                    src={recurring_deliveries}
                    alt="Cost Efficiency"
                    style={{
                      maxWidth: "90%",
                      position: 'absolute',
                      maxHeight: "80%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* card 2 */}
           <div className="col-12 col-sm-12 col-lg-8">
            <div
              className="card border-0 rounded-5"
              style={{
                height: "350px",
                background: "linear-gradient(180deg, #f4ebfd, #bda8f9)",
                overflow: "hidden",
              }}
            >
             <div
                className="card-body d-flex flex-column"
                style={{ height: "100%" }}
              >
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Wide Range Of Vehicles 
                </h3>

                <div
                  style={{
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "end",
                    
                  }}
                >
                  <img
                    src={wide_range_of_vehicles}
                    alt="wide_range_of_vehicles"
                    style={{
                      width: "100%",
                      position: 'absolute',
                      height: "100%",
                      // objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* card 3 */}
          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0 rounded-5"
              style={{
                height: "350px",
                background: "linear-gradient(180deg, #fcede2, #f8c275)",
                overflow: "hidden",
              }}
            >
              <div
                className="card-body d-flex flex-column"
                style={{ height: "100%" }}
              >
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black" style={{maxWidth: '55%'}}>
                  Centralized Booking Dashboard
                </h3>

                <div
                  style={{
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "end",
                  }}
                >
                  <img
                    src={centralized_booking_dashboard}
                    alt="Cost Efficiency"
                    style={{
                      maxWidth: "90%",
                      position: 'absolute',
                      maxHeight: "80%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* card 4 */}
          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0 rounded-5"
              style={{
                height: "350px",
                background: "#e0fbcf",
                overflow: "hidden",
              }}
            >
              <div
                className="card-body d-flex flex-column"
                style={{ height: "100%" }}
              >
                <h3 className="card-title fw-bold fs-5 mb-3 mt-4 text-black">
                  Real-Time Tracking
                </h3>

                <div
                  style={{
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "end",
                  }}
                >
                  <img
                    src={real_time_tracking}
                    alt="Cost Efficiency"
                    style={{
                      maxWidth: "90%",
                      position: 'absolute',
                      maxHeight: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* card 5 */}
          <div className="col-12 col-sm-6 col-lg-4">
            <div
              className="card border-0 rounded-5"
              style={{
                height: "350px",
                background: "linear-gradient(180deg, #F5FBFD, #ace5fb)",
              }}
            >
              <div className="card-body d-flex flex-column h-100">
                <h3
                  className="card-title fw-bold fs-5 mb-3 mt-4 text-black"
                  style={{ width: "43%" }}
                >
                  Smart Billing & Wallet
                </h3>
                <div className="d-flex justify-content-center align-items-end flex-grow-1 mt-3">
                  <img
                    src={smart_billing_wallet}
                    alt="Tailored for Restaurants"
                    className="img-fluid rounded-4"
                    style={{ maxHeight: "240px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;
